import React from 'react';
import cn from 'classnames';

import { idxMap } from 'helpers/styleMapIdx';

import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import {
  EXIT_CAUSE_ICONS,
  type SessionVerdictContent,
} from '../../TimelineSection.helpers';

import styles from './SessionVerdict.module.scss';

const CAUSE_VARIANTS = {
  error: styles.verdictError,
  stuck: styles.verdictStuck,
  goal: styles.verdictGoal,
  left: styles.verdictLeft,
  idle: styles.verdictIdle,
};

/** DS Notification (Figma 1241:987) coloured by the exit cause. */
const SessionVerdict = ({
  verdict,
  onCauseEventJump,
}: {
  verdict: SessionVerdictContent;
  onCauseEventJump: (eventIndex: number) => void;
}) => {
  const { causeEventIndex, jumpLabel } = verdict;

  return (
    <div
      className={cn(
        styles.verdict,
        idxMap(CAUSE_VARIANTS as Record<string, string>, verdict.cause),
      )}
    >
      <Icon className={styles.icon} name={EXIT_CAUSE_ICONS[verdict.cause]} />
      <div className={styles.content}>
        <Typography
          className={styles.title}
          variant="body2"
          weight="medium"
          title={
            verdict.fullTitle && verdict.fullTitle !== verdict.title
              ? verdict.fullTitle
              : undefined
          }
        >
          {verdict.title}
        </Typography>
        <Typography className={styles.text} variant="body3">
          {verdict.text}
        </Typography>
        {verdict.notes.map((note) => (
          <Typography key={note} className={styles.text} variant="body3">
            {note}
          </Typography>
        ))}
      </div>
      {jumpLabel && causeEventIndex != null ? (
        <Button
          className={styles.button}
          variant="outlined"
          size="sm"
          onClick={() => onCauseEventJump(causeEventIndex)}
        >
          {jumpLabel}
        </Button>
      ) : null}
    </div>
  );
};

export default React.memo(SessionVerdict) as any;
